import { gql } from '@apollo/client'

const ACTION_GOAL_SUMMARIES = gql`
  query actionGoalSummaries($startDate: ISO8601Date!) {
    actionGoalSummaries(startDate: $startDate) {
      startDate
      actionGoalSummaries {
        id
        completions {
          date
        }
        actionGoal {
          id
          kind
          numberDays
          startDate
          metricKind
          metricValue
          displayUnits
          title
          description
          icon
          category
          macroGoal
          goalText
          summaryDescription
        }
      }
    }
  }
`

export default ACTION_GOAL_SUMMARIES
